export function createValidationRules(t) {
  return {
    // required: value => !!value || t('validmsg.required'),
    required: value => !!value || t('validmsg.required'),

    firstNameRules: [
      value => {
        if (!value) return t('validmsg.required')
        if (value.length < 2) return t('validmsg.min', { min: 2 })
        if (/^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9\s-]+$/.test(value)) return true

        return t('validmsg.invalid')
      },
    ],

    lastNameRules: [
      value => {
        if (!value) return t('validmsg.required')
        if (value.length < 2) return t('validmsg.min', { min: 2 })
        if (/^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9\s-]+$/.test(value)) return true

        return t('validmsg.invalid')
      },
    ],

    emailRules: [
      value => {
        if (!value) return true
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (emailRegex.test(value)) return true

        return t('validmsg.email')
      },
    ],
    // phoneRules: [
    //   value => {
    //     // E.164 standard for international numbers
    //     const phoneRegex = /^\+?[1-9][0-9\s-]{7,14}$/
    //     if (phoneRegex.test(value)) return true
    //
    //     return t('validmsg.phone')
    //   },
    // ],
    phoneRules: [
      value => {
        if (!value) return true

        // For phone numbers without prefix (since prefix is a separate field)
        const digitOnlyRegex = /^[\d\s-]{6,15}$/

        // Specific validation for Polish and UK numbers without the prefix
        const polandNumberRegex = /^[\d\s-]{9}$/
        const ukNumberRegex = /^[\d\s-]{10}$/

        // For international format with country code
        const internationalFormatRegex = /^\+\d{1,3}[\d]{6,12}$/

        if (digitOnlyRegex.test(value) ||
          polandNumberRegex.test(value) ||
          ukNumberRegex.test(value) ||
          internationalFormatRegex.test(value)) return true

        return t('validmsg.phone')
      },
    ],
    zipCodeRules: [
      value => {
        if (!value) return true // Allow empty values

        // Polish postal code format: XX-XXX
        const zipCodeRegex = /^\d{2}-\d{3}$/

        if (zipCodeRegex.test(value)) return true

        return t('validmsg.zipcode', { format: '00-000' })
      },
    ],
    fullNumberRules: [
      value => {
        // Regex to allow only positive integers without decimals
        const positiveIntegerRegex = /^\d+$/
        if (positiveIntegerRegex.test(value)) return true

        return t('validmsg.onlyPositiveFullNumbers')
      },
    ],
    numberRules: [
      value => {
        // Regex to allow only positive integers + and -
        const integerRegex = /^-?\d+$/
        if (integerRegex.test(value)) return true

        return t('validmsg.onlyNumbers')
      },
    ],
    // Positive number rules without zero
    positiveNumberRules: [
      value => {
        // Check specifically for zero value
        if (value === 0 || value === '0') {
          return t('validmsg.onlyPositiveNumbers')
        }

        // Regex to allow only positive numbers (integers and decimals) but not zero
        const positiveNumberRegex = /^[+]?([1-9]\d*\.?\d*|\d*\.\d+)$/
        if (positiveNumberRegex.test(value)) return true

        return t('validmsg.onlyPositiveNumbers')
      },
    ],
    // maximum number rule
    maxNumberRule: max => value => {
      const numberValue = parseFloat(value)
      if (isNaN(numberValue)) return t('validmsg.value_to_big') // Handle non-numeric input
      if (numberValue <= max) return true

      return t('validmsg.value_to_big', { max })
    },

    externalRule: (isValid, message) => {
      return isValid ? true : message
    },
    maxNumberLength: maxLength => value => {
      if (!value) return true
      if (value.toString().length <= maxLength) return true

      return t('validmsg.maxLength', { maxLength })
    },

    // Non-negative number rule accepting zero and positive numbers
    nonNegativeNumberRules: [
      value => {
        // Check if value is missing
        if (value === '' || value === null || value === undefined)
          return t('validmsg.required')

        // Check if the value is a number and non-negative
        const numValue = Number(value)
        if (isNaN(numValue))
          return t('validmsg.onlyPositiveFullNumbers')

        // Check if value is non-negative (zero or positive)
        if (numValue >= 0) return true

        return t('validmsg.onlyPositiveFullNumbers')
      },
    ],

  }
}

// Example use
// const validationRules = createValidationRules(t)
// as prop -> :rules="[validationRules.required]"
